import { render, staticRenderFns } from "./pfh-link.vue?vue&type=template&id=2a2498db&"
import script from "./pfh-link.vue?vue&type=script&lang=js&"
export * from "./pfh-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports